import {
  Camera,
  Hand,
  Mic,
  MoreHorizontal,
  Octagon,
  Sparkles,
  Thermometer,
  Volume2,
  Wifi,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { CATEGORY_I18N_MAP } from '../constants';

const ICON_MAP: Record<string, React.ComponentType<{ className?: string }>> = {
  Mic,
  Camera,
  Volume2,
  Hand,
  Octagon,
  Wifi,
  Thermometer,
  Sparkles,
  MoreHorizontal,
};

interface Category {
  category: string;
  label: string;
  icon: string;
}

interface CategoryGridProps {
  categories: Category[];
  selected: string | null;
  onSelect: (category: string) => void;
}

export function CategoryGrid({ categories, selected, onSelect }: CategoryGridProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-3 gap-3">
      {categories.map(cat => {
        const Icon = ICON_MAP[cat.icon] ?? MoreHorizontal;
        const isSelected = selected === cat.category;
        const i18nKey = CATEGORY_I18N_MAP[cat.category];
        const translatedLabel = i18nKey ? t(i18nKey) : cat.label;

        return (
          <button
            key={cat.category}
            type="button"
            onClick={() => onSelect(cat.category)}
            className={`flex flex-col items-center gap-2 rounded-xl border-2 p-4 text-center transition-all ${
              isSelected
                ? 'border-primary bg-primary/10 text-primary'
                : 'border-border hover:border-primary/50 hover:bg-muted'
            }`}
            aria-label={translatedLabel}
          >
            <Icon className="h-6 w-6" />
            <span className="text-xs font-medium leading-tight">{translatedLabel}</span>
          </button>
        );
      })}
    </div>
  );
}
